import React  from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthLayout } from '../../Layouts'
import { Login, ForgotPassword, VerifyEmail, EmailChange } from './Auth'

export default function Unauthorized() {
  return (
    <AuthLayout>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/reset-password' element={<ForgotPassword />} />
        <Route path='/verify-email' element={<VerifyEmail />} />
        <Route path='/email-change' element={<EmailChange />} />
        <Route path='*' element={<Navigate replace to='/login' />} />
      </Routes>
    </AuthLayout>
  )
}
